import React from 'react'
import { Row, Col, Container } from 'react-bootstrap'
import Slider from 'react-slick'
import ReactHtmlParser from 'react-html-parser'
import get from 'lodash.get'

import CardInfoWithIcon from 'components/molecules/CardInfoWithIcon'
import Typography from 'components/atoms/Typography'
import 'slick-carousel/slick/slick.css'

import './InformationTagWrapper.scss'

function InformationTagWrapper({ data }) {
  const id = get(data, 'id')
  const title = get(data, 'title')
  const description = get(data, 'description.value')
  const themeClasses = get(data, 'theme.entity.classes')

  const sliderSettings = {
    dots: true,
    dotsClass: `slick-dots primary`,
    arrows: false,
    infinite: false,
    variableWidth: true,
    slidesToShow: 4.5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4.5,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  }

  return (
    <Container id={id} fluid="fluid" className={`${themeClasses ? themeClasses : ''} information-tag-wrapper ${title && 'section-spacing'} pt-lg-5`}>
      <Container className='information-tag-wrapper__box d-flex flex-column'>
        {title && (
          <Typography variant="h2" cssClass="information-tag-wrapper__title text-center title-bold-md mb-3">
            {title}
          </Typography>
        )}
        {description && (
          <div className={`info-tags-description text-center information-tag-wrapper__description mb-3 mb-lg-4`}>
            {ReactHtmlParser(description)}
          </div>
        )}
        <div className="d-none d-md-block">
          <Row>
            {data.items.map(({ entity }, index) => (
              <Col sm="12" md="6" className="mb-md-3 mb-lg-4" key={data.uuid + index}>
                <CardInfoWithIcon
                  id={get(entity, 'id')}
                  ctaText={get(entity, 'link.entity.link.title')}
                  icon={get(entity, 'icon.entity.media.entity.fieldMediaFile.entity.url')}
                  linkType={get(entity, 'link.entity.linkType.entity.token')}
                  title={get(entity, 'title')}
                  description={get(entity, 'description.value')}
                  theme={get(entity, 'theme.entity.classes')}
                  url={get(entity, 'link.entity.link.url.path')}
                  key={get(entity, 'id') + get(entity, 'uuid')}
                />
              </Col>
            ))}
          </Row>
        </div>

        <div className="d-md-none">
          <Slider {...sliderSettings}>
            {data.items.map(({ entity }) => (
              <CardInfoWithIcon
                id={get(entity, 'id')}
                icon={get(entity, 'icon.entity.media.entity.fieldMediaFile.entity.url')}
                description={get(entity, 'description.value')}
                ctaText={get(entity, 'link.entity.link.title')}
                slide={true}
                title={get(entity, 'title')}
                linkType={get(entity, 'link.entity.linkType.entity.token')}
                theme={get(entity, 'theme.entity.classes')}
                url={get(entity, 'link.entity.link.url.path')}
                key={get(entity, 'id') + get(entity, 'uuid')}
                wrapper={true}
              />
            ))}
          </Slider>
        </div>
      </Container>
    </Container>
  )
}

export default InformationTagWrapper
